import React from "react";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import { ChangeContainer, ChangeIcon, ChangeText } from "./PerformanceStyles";

interface PercentageChangeIndicatorProps {
  percentageChange: number;
  polarity: "positive" | "negative";
}

const PercentageChangeIndicator: React.FC<PercentageChangeIndicatorProps> = ({
  percentageChange,
  polarity,
}) => {
  const isIncrease = percentageChange > 0;
  const isGoodChange = polarity === "positive" ? isIncrease : !isIncrease;
  const Icon = isIncrease ? ArrowUpward : ArrowDownward;
  const sign = isIncrease ? "+" : "";
  const formattedPercentage = `${sign}${percentageChange.toFixed(1)}%`;

  return (
    <ChangeContainer isGoodChange={isGoodChange}>
      <ChangeIcon isGoodChange={isGoodChange}>
        <Icon />
      </ChangeIcon>
      <ChangeText isGoodChange={isGoodChange}>{formattedPercentage}</ChangeText>
    </ChangeContainer>
  );
};

export default PercentageChangeIndicator;
